import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

const credentialTypes = ['customer-code', 'authentication-code'] as const

export type jleiCredType = (typeof credentialTypes)[number]
export const jleiDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const jlei: CarrierDef<jleiCredType> = {
  name: 'Lee Jennings Target Express',
  scac: 'jlei',
  credentialTypes,
  engineLayers: ['rating', 'pickup', 'tracking', 'documents'],
  documentTypes: jleiDocumentTypes,
  legacyCredMap: [
    ['customer-code', 'customerCode'],
    ['authentication-code', 'authenticationCode'],
  ],
  credentialConfig: {
    'authentication-code': {
      type: 'text',
    },
    'customer-code': {
      type: 'text',
    },
  },
}
